import React, { useContext, useEffect } from "react";
import {
    ButtonProps,
    ButtonRenderProps,
    ClearFiltersButton,
    ContentSection,
    createListTableColumns,
    Grid,
    GridColumn,
    GridRow,
    ListTable,
    renderDateTime,
    SearchBox,
    Stack
} from "sprint-common-web";

import { DistributorListingContext } from "../context/DistributorListingContext";
import { DistributorListingItem } from "../context/DistributorsListingItem";
import { AddDistributorButton } from "./buttons/AddDistributorButton";
import { useDistributorsListingFilters } from "./useDistributorsListingFilters";

export const DistributorsListing: React.FC = () => {
    const { filters, setName, setPage, setPageSize, clearFilters, setSort } = useDistributorsListingFilters();
    const { totalItems, isLoading, items, loadData } = useContext(DistributorListingContext);

    const columns = createListTableColumns<DistributorListingItem>([
        {
            type: "basic",
            key: "name",
            name: "Name",
            minWidth: 200,
            maxWidth: 350,
            isSortable: true
        },
        {
            type: "basic",
            key: "alias",
            name: "Alias",
            minWidth: 200,
            maxWidth: 350,
            isSortable: true
        },
        {
            type: "basic",
            key: "buzzId",
            name: "Buzz",
            minWidth: 200,
            maxWidth: 350,
            isSortable: false
        },
        {
            type: "basic",
            key: "shreqId",
            name: "Shreq",
            minWidth: 200,
            maxWidth: 350,
            isSortable: false
        },
        {
            type: "basic",
            key: "updatedDate",
            name: "Updated",
            minWidth: 200,
            maxWidth: 400,
            isSortable: true,
            onRender: renderDateTime
        }
    ]);

    useEffect(() => {
        loadData(filters);
    }, [filters]);

    const addDistributorButtonProps: ButtonRenderProps<ButtonProps> = {
        render: AddDistributorButton
    };

    return (
        <ContentSection header={"Distributors"} buttons={[addDistributorButtonProps]}>
            <Grid>
                <GridRow>
                    <GridColumn sm={4}>
                        <SearchBox placeholder="Name" onChange={setName} value={filters.name} />
                    </GridColumn>

                    <GridColumn sm={8}>
                        <Stack horizontalAlign="end">
                            <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                        </Stack>
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <ListTable
                            columns={columns}
                            items={items}
                            pagination={{
                                page: filters.page,
                                pageSize: filters.pageSize,
                                totalItems,
                                onPageChange: setPage,
                                onPageSizeChange: setPageSize
                            }}
                            sort={{ by: filters.sortBy, order: filters.sortOrder }}
                            onSortChange={setSort}
                            isLoading={isLoading}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};
